/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

import Vue from 'vue';

// message passing bus
// noinspection JSUnusedGlobalSymbols
export default new Vue();

// TODO: add messageBus emit wrappers to do type checking
